/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

// Libraries
import * as Linking from 'expo-linking';


const linking = {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
      Loading: 'Loading',
      EersteScherm: 'Welkom',
      Login: 'Login',
      Registreer: 'Registeer',
      GegevensAanvullen: 'GegevensAanvullen',
      WwVergeten: 'WachtwoordVergeten',
      GezinToevoegen: 'GezinToevoegen',
      shopScreen: 'Shop',
      GegevensScreen: 'GegevensScreen',
      GezinsScreen: 'GezinsScreen',
      accountScreen: 'Account',
      wwWijzigen: 'WachtwoordWijzigen',
      wwHerstellen: 'WachtwoordHerstellen',
      Winkelmand: 'Winkelmand',
      BestellingDetails: 'BestellingDetails',
      EmailBevestigen: 'EmailBevestigen',
      DankjeScherm: 'Dankje',
      Contact: 'Contact',
      Privacyverklaring: 'Privacyverklaring',
      AlgemeneVoorwaarden: 'AlgemeneVoorwaarden',
      RetourBeleid: 'Retourbeleid',
      NotFound: '*'
    }
  },
};

export default linking;
